import React from "react";

export default function ScrollToTop() {
  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div onClick={scrollToTop}>
      <i
        className={
          "fas fa-arrow-circle-up fa-3x floating-button scroll-top text-safy-success"
        }
        style={{ height: 40, display: "flex" }}
      />
    </div>
  );
}
